import { centeredColumn } from "./centered-column";
import { div } from "./van-tags";

/**
 * @param {Object} cfg
 * @param {"narrow"|"wide"} cfg.size
 * @param  {...import("vanjs-core").ChildDom} children
 */
export function centeredBox(cfg, ...children) {
	return centeredColumn(
		cfg,
		div(
			{
				class: "box",
			},
			...children,
		),
	);
}
